import { Box } from '@mui/material';
import { BodyText, TitleText } from 'Application/components';
import { FC, useEffect } from 'react';
import MainCard from 'ui-component/cards/MainCard';
import { getUserDataFromStorage } from 'Application/utils/AppSessionStorage';
import AdminDashboard from '../Shared/statistics';
import { useAuth } from 'Application/context/AuthContext';

interface BritamAdminHomeProps {}

const getCurrentTimeOfDay = () => {
    const currentHour = new Date().getHours();

    if (currentHour >= 5 && currentHour < 12) {
        return 'Morning';
    } else if (currentHour >= 12 && currentHour < 18) {
        return 'Afternoon';
    } else {
        return 'Evening';
    }
};

export const BritamAdminHome: FC<BritamAdminHomeProps> = () => {
    const fname = getUserDataFromStorage()?.firstName;
    const timeOfDay = getCurrentTimeOfDay();

    const { toggleRefresh } = useAuth();

    useEffect(() => {
        toggleRefresh(true);
    }, []);

    return (
        <>
            <MainCard>
                <Box>
                    <TitleText text={`Good ${timeOfDay}, ${fname}!`} />
                    <BodyText text={'Welcome to the Britam Admin Portal'} />
                </Box>
            </MainCard>

    

            <AdminDashboard />
        </>
    );
};
